import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging
import axios from "axios"; // For making HTTP requests

const signDevis = async (
  champs,
  urlpdf,
  token,
  devisid,
  prefix,
  height,
  width,
  page
) => {
  const url = prefix + `hexasign/devis/${devisid}/sign`;

  // Modify Champs types and content as per the original logic
  champs.forEach((champ) => {
    if (champ.type === "Initiales") {
      champ.type = "Signature";
    } else if (champ.type === "Coche") {
      champ.type = "Tampon";
      champ.w = 20;
      champ.h = 20;
      champ.content =
        champ.content === "true"
          ? "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochetrue.png?alt=media&token=54b36cc7-13e9-4a07-8edb-dd87705ca982"
          : "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochefalse.png?alt=media&token=74043f9c-b3fe-450f-b813-8c5e48a70af2";
    }
  });

  const fields = champs;

  // Request body
  const body = {
    pdf: urlpdf,
    fields: fields,
    signature_details: {
      height: height,
      width: width,
    },
    target_height: height,
    target_width: width,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Send POST request
    const response = await axios.post(url, body, { headers });
    // Check response
    if (response.status === 200) {
      const jsonResponse = response.data;
      return jsonResponse["pdf"];
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default signDevis;
